{
  "053da7dd31d9cb21": "Try another way to sign in ({{methods}})",
  "0637d8a0a26252f2": "Get Sign-in Link",
  "086c9a6735ae3533": "Reset your password to sign in again.",
  "0a36f5f5f26c781a": "Verification link sent",
  "10b91c86cc845dd0": "We sent an 8-digit code to {{email}}.",
  "1289b9ed7ee09a56": "This login link is no longer supported",
  "13ac4145be6db27e": "We verified your code, but couldn't load your account. Please try again in a moment, or contact support if the problem continues.",
  "1532713d4f08d3e2": "First login or forgot your password?",
  "17dc61dc6613b142": "This email belongs to a Clipboard Worker account, which can't access the Clipboard Workplace app. Download Clipboard - Workers to sign in and find shifts.",
  "181f0a7807626f67": "Resend code in {{seconds}}s",
  "1ccc5e7afaa21909": "Go back to login page",
  "22366d1a37d767a5": "Download on Google Play Store",
  "25a200daeda8bad0": "Resend link",
  "2669c73293ad3767": "Use SSO instead",
  "27bc15da205e30ef": "email code",
  "299766bd055393d3": "By clicking \"{{action}}\" you agree to Clipboard's",
  "2dd2d99a5e26f0d5": "We have sent an email with a login link to {{email}}.",
  "2f7d12e23f228c17": "Try another way to sign in",
  "31fbef162594de01": "Continue",
  "36e321e7d3c3004e": "Get Sign-in Code",
  "37b6a0fef1e97e04": "Enter your email address and we'll send you a link to reset your password.",
  "39c77ab769fb6557": "Password recovery options",
  "3ccd9d6586ef9143": "Something went wrong. Please try again.",
  "3dd9df4441fb348f": "New password",
  "3ee75029c70e284c": "Verification code",
  "3f3dc55f6031405f": "Use email code",
  "428a33989323fe5a": "Back to password",
  "42cc251ca8e5f50c": "Get a new code",
  "42d47e9af744146e": "We couldn't sign you in with a passkey for this email. If you have an account, sign in with a link or password, then add a passkey from the My Account page.",
  "4554bbfc7a435f3d": "This code has expired. Tap \"Resend code\" to get a new code.",
  "4935425fcdfdefbf": "We signed you in, but couldn't load your account. Please try again in a moment, or contact support if the problem continues.",
  "4afa55bf7aec7ddc": "Terms of Service",
  "4b949c1309045061": "passkey",
  "4bdfea0578b5a2ab": "Unable to start SSO sign-in. Please try again.",
  "4f44603ef678e4cb": "Resend email",
  "50000feaf7e92d26": "Sign in with email & password",
  "506ff394621596dd": "Privacy Policy",
  "51b2b1ccd055a31d": "We sent an 8-digit code to {{email}}. The code expires in {{timeRemaining}}. Enter it below to sign in.",
  "51db7056c95080a7": "Choose how you'd like to sign in to {{email}}.",
  "525183e72edd7009": "Password must be at least {{minLength}} characters.",
  "52d97b05b86d5e7f": "We couldn't sign you in with a passkey for this email. If you have an account, sign in with a code or password, then add a passkey from the My Account page.",
  "59fa4379be1f3398": "Reset your password",
  "5ba3ac9fc8e84781": "SSO",
  "5bfc870d1f1bda87": "Password must be at least {{minLength}} characters and include uppercase and lowercase letters.",
  "5e2b8e96503d722e": "Sign up",
  "603357d553ea66eb": "Reset your password to sign in again, or use another available method.",
  "609e2a776c1cdc73": "We have sent a password reset link to {{email}}. Check your email and follow the instructions.",
  "61c2a73c39324121": "We sent an 8-digit code to {{email}}. Enter it below to sign in.",
  "62fd9988e2dff052": "Enter your code",
  "648b5daecda082e6": "Please enter a valid email address to sign in with a passkey.",
  "6621249514b7887c": "Welcome back",
  "6b8997d86e4579c8": "This code has expired.",
  "6c6e178ad2a856ca": "Passwords do not match.",
  "702fcd077076f17c": "Sign in with code",
  "708c5d67ba8e2818": "Send reset link",
  "714f61c8f06be4c6": "That sign-in code is invalid or has expired. Request a new code.",
  "7175517a370b5cd2": "or",
  "71fe31ccd37c3268": "Back to sign in",
  "72b478e8cf489a6d": "Send another email",
  "73e8c6ec76e1c6e7": "Please enter your email address to verify login link",
  "73e984e9b4809573": "Sign in with SSO",
  "756d8e49571547a6": "reset your password",
  "768eb37ace3f3544": "Enter your email address and we'll send you a link to set/reset your password.",
  "76d8884f1f1b1450": "Enter it below to sign in.",
  "79a5190510175d40": "Sign in with link",
  "7c04058cb9fcd308": "Your passkey was verified, but this email belongs to a healthcare professional account, which is not allowed to post shifts and therefore cannot access this app. Please use the mobile app \"Clipboard - Workers\" to sign in instead.",
  "7d5f16d496d4e50d": "Send Reset Link",
  "8236bebffed7dcf2": "You can resend the code in {{seconds}} seconds.",
  "82cdc06b5f2042ae": "Your sign-in session is no longer available.",
  "8477488cb2198e2d": "We set your password, but couldn't load your account. Please try again in a moment, or contact support if the problem continues.",
  "887a560b8253e394": "Set a new password",
  "888326a0ca0075ea": "Resend email in {{seconds}}s",
  "8d137aeec7706c5e": "Initiate sign in again to get a fresh code or link.",
  "8d9c49d849971d2b": "We couldn't reach Clipboard's servers. Check your internet connection and try again.",
  "91fbfebf41d86a8c": "Email me a sign-in link",
  "928443dc9d5b845c": "Please enter your email address first.",
  "955c997aa0afb2f6": "Your password must be replaced before you can sign in.",
  "969ccbd3cf6300ec": "Email",
  "98b67063cf8e584d": "Contact Us",
  "9ae9fbbcb1c80ca9": "Verify Email",
  "9beaac734f70f395": "That code is incorrect or expired. Go back and request a new code.",
  "a538e4cfd1033f16": "Your account is active, but it isn't linked to an active workplace. Ask a workplace administrator to link your account to a workplace, then try again.",
  "aaa44fb9c12cc0cd": "Resend link in {{seconds}}s",
  "aead8ab55bd0b8e6": "Reset link sent",
  "afc99407f7773457": "Signing you in…",
  "afd25fdf17c7f534": "Forgot your password?",
  "b09700bcd53283b4": "Sign in with a passkey",
  "b1585a7650b2cac9": "This email isn't verified yet, so password sign-in and password reset aren't available. Use the code we send to your email to sign in.",
  "b4abb2b61e6583a1": "Password must be at least {{minLength}} characters, include uppercase and lowercase letters, and not start or end with a space.",
  "b84cc3347b94fc0c": "Go to login",
  "b8ed5279e897be5d": "Sending…",
  "b97457409ab5b375": "Resend code",
  "baa3717a3b7e266c": "Use the Clipboard Worker app",
  "bcc0bcc9140b0c97": "Sign In",
  "bd347f8daa7d232e": "Set new password and sign in",
  "bedac809a0ca6e58": "Sign in with password",
  "bf000421aeb39493": "Confirm new password",
  "bfd402b2f6f38125": "Sign in",
  "c2e34604b7790d68": "Enter your email to get started",
  "c473cfc3f1f6e46f": "Please enter your email id again to verify login link",
  "ca009c3212e4e3d0": "Your new password can't start or end with a space.",
  "cc8fd9eb7f959b13": "Welcome!",
  "ccd534e0d967abf1": "Download on the App Store",
  "d08eeabe9e9ab437": "Your password was set, but this email belongs to a healthcare professional account, which is not allowed to post shifts and therefore cannot access this app. Please use the mobile app \"Clipboard - Workers\" to sign in instead.",
  "d3c02b7f195aad5a": "You signed in with a temporary password. Choose a new one to finish signing in.",
  "d5b3d634503bb920": "Enter your password to sign in",
  "d5e8f4562f0730f7": "The submitted code was correct, but this email belongs to a healthcare professional account, which is not allowed to post shifts and therefore cannot access this app. Please use the mobile app \"Clipboard - Workers\" to sign in instead.",
  "d6687d2b32178d9e": "Email me a sign-in code",
  "d6af827c633fe08f": "We verified your passkey, but couldn't load your account. Please try again in a moment, or contact support if the problem continues.",
  "d768ad08c1cd73e9": "Your sign-in session is no longer available. Tap \"Resend code\" to get a new code.",
  "d968ef24f7787160": "Scan to download",
  "e0edfeb3a71a1002": "Reset password",
  "e3cccfa0cfe08ece": "Get a new email code",
  "e7cf3ef4f17c3999": "Password",
  "e7f40c5f5b7ee8dc": "No passkey is set up for this email. You can create one after logging in, from the My Account page.",
  "eaf8ba323e085de5": "Don't have a workplace account?",
  "eb80b7b5166b0a83": "That password didn’t work. Try again or",
  "efd29d8c54d0a8ff": "Take Clipboard with you",
  "f1490d02cf2acb0c": "Use email code instead",
  "f338d4463a3bccc7": "and acknowledge that you have read our",
  "f355a29d0f6ec70f": "Use passkey instead",
  "f47dcbafb3c566f5": "Your password was correct, but this email belongs to a healthcare professional account, which is not allowed to post shifts and therefore cannot access this app. Please use the mobile app \"Clipboard - Workers\" to sign in instead.",
  "f4db79df54a07c19": "Set/reset password",
  "f8aca558a662428a": "Password must include at least one uppercase and one lowercase letter.",
  "f9e99faee0617e78": "Download our mobile app to view your schedule, post shifts, and manage your workers on the go.",
  "fd5282f5a924a2ba": "Send Set/Reset Link",
  "fe3dff2dfb7994c7": "You can resend the code in 1 second.",
  "fe40fa3034212960": "Sign in with email and password",
  "ff2c7333bb883550": "Sign-in link sent",
  "ff2ec2618b91b367": "Change email"
}
